import { api, unwrap, type Schemas } from '../../api/client';

export type PlatformWhatsapp = Schemas['PlatformWhatsapp'];
export type WhatsappPeriod = Schemas['WhatsappPluginPeriod'];
export type WhatsappRevenue = Schemas['WhatsappRevenue'];

export const whatsappKeys = {
  tenant: (id: string) => ['platform', 'whatsapp', 'tenant', id] as const,
  revenue: ['platform', 'whatsapp', 'revenue'] as const,
};

export function fetchTenantWhatsapp(id: string) {
  return unwrap(api.GET('/platform/tenants/{id}/whatsapp', { params: { path: { id } } }));
}

export function fetchWhatsappRevenue() {
  return unwrap(api.GET('/platform/whatsapp/revenue'));
}

export const PERIOD_LABELS: Record<WhatsappPeriod['kind'], string> = {
  ENABLED: 'Enabled',
  EXTENDED: 'Extended',
  GRACE_CHANGED: 'Grace changed',
  DISABLED: 'Turned off',
};
